import React from 'react';
import './NavbarItem.css';
import { FaPlus, FaMinus } from 'react-icons/fa';
import { Link } from 'react-router-dom';

// 1. IMPORT HOOKA DO TŁUMACZEŃ
import { useTranslation } from 'react-i18next';

const NavbarItem = (props) => {
    // 2. INICJALIZACJA TŁUMACZEŃ
    const { t } = useTranslation();

    const { id, mainLink, subLink, isActive, onNavLinkClick } = props;

    const hasSublinks = subLink && subLink.length > 0;

    return (
        <div className="nav-link">
            {/* Główny kontener linku */}
            <div 
                className={`main-nav-link ${isActive ? 'active' : ''}`} 
                onClick={() => onNavLinkClick(id)}
            >
                {/* 3. TŁUMACZENIE: Jeśli są sublinki, renderujemy tekst, jeśli nie - zwykły Link */}
                {hasSublinks ? (
                    <span className="nav-btn">
                        {mainLink.titleKey ? t(mainLink.titleKey) : mainLink.title}
                    </span>
                ) : (
                    <Link className="nav-btn" to={mainLink.link}>
                        {mainLink.titleKey ? t(mainLink.titleKey) : mainLink.title}
                    </Link>
                )}

                {/* Ikona plus/minus tylko gdy są sublinki */}
                {hasSublinks && (
                    <div className="icon">
                        {isActive ? <FaMinus /> : <FaPlus />}
                    </div>
                )}
            </div>

            {/* Sub-nawigacja - renderowana tylko gdy aktywna i są elementy */}
            {isActive && hasSublinks && (
                <div className="sub-nav-link">
                    {subLink.map((item) => (
                        <Link to={item.link} state={item.state} key={item.id}>
                            {/* 4. TŁUMACZENIE PODLINKÓW */}
                            {item.titleKey ? t(item.titleKey) : item.title}
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
};

export default NavbarItem;